import { useCallback, useEffect, useRef, useState } from "react";
import { useAuth } from "../components/Login/AuthContext";
import { pickRegion } from "../data/region";

// Region state that starts from the teacher's likely curriculum and follows it once
// their profile loads, until they pick a region themselves.
export function useRegion(initialRegion = null) {
  const auth = useAuth();
  const defaultRegion = auth?.defaultRegion ?? pickRegion(null);
  const [region, setRegion] = useState(initialRegion ?? defaultRegion);
  const chosenRef = useRef(Boolean(initialRegion));

  useEffect(() => {
    if (!chosenRef.current) setRegion(defaultRegion);
  }, [defaultRegion]);

  const chooseRegion = useCallback((next) => {
    chosenRef.current = true;
    setRegion(next);
  }, []);

  return [region, chooseRegion];
}
